(function () {
  function replaceToken(message, token, value) {
    return String(message || '').split(token).join(value || '');
  }

  function messageForTable(template, table, area) {
    const withTable = replaceToken(template, '[table]', table);
    const withArea = replaceToken(withTable, '[area]', area);

    return withArea
      .replace(/\s+·\s*$/, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function parseTableNumber(rawValue) {
    const value = String(rawValue || '').trim();

    if (!/^\d+$/.test(value)) return null;

    const number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }

  function parseConfiguration(root) {
    const source = root.querySelector('[data-online-ordering-data]');

    if (!source) return null;

    try {
      return JSON.parse(source.textContent || '{}');
    } catch (error) {
      console.warn('[Online ordering] Invalid configuration.', error);
      return null;
    }
  }

  function createTableLookup(tables) {
    const lookup = new Map();

    (tables || []).forEach(function (table) {
      const number = Number(table.number);
      const url = String(table.url || '').trim();

      if (!Number.isSafeInteger(number) || number < 1 || !url) return;

      lookup.set(number, {
        area: String(table.area || '').trim(),
        name: String(table.name || 'Table ' + number).trim(),
        url: url
      });
    });

    return lookup;
  }

  function initialize(root) {
    if (!root || root.dataset.onlineOrderingInitialized === 'true') return;

    root.dataset.onlineOrderingInitialized = 'true';

    const parameters = new URLSearchParams(window.location.search);
    root.dataset.onlineOrderingMode = parameters.get('mode') === 'table' ? 'table' : 'default';

    const configuration = parseConfiguration(root);
    const form = root.querySelector('[data-online-ordering-form]');
    const input = root.querySelector('[data-online-ordering-input]');
    const submit = root.querySelector('[data-online-ordering-submit]');
    const status = root.querySelector('[data-online-ordering-status]');
    const error = root.querySelector('[data-online-ordering-error]');

    if (!configuration || !form || !input || !submit || !status || !error) return;

    const messages = configuration.messages || {};
    const tables = createTableLookup(configuration.tables);

    function disableSubmit() {
      submit.removeAttribute('href');
      submit.setAttribute('aria-disabled', 'true');
      submit.setAttribute('tabindex', '-1');
    }

    function enableSubmit(url) {
      submit.href = url;
      submit.setAttribute('aria-disabled', 'false');
      submit.removeAttribute('tabindex');
    }

    function clearFeedback() {
      input.removeAttribute('aria-invalid');
      status.hidden = true;
      status.textContent = '';
      error.hidden = true;
      error.textContent = '';
    }

    function showError(message) {
      input.setAttribute('aria-invalid', 'true');
      disableSubmit();
      status.hidden = true;
      status.textContent = '';
      error.textContent = message;
      error.hidden = false;
    }

    function validate(options) {
      const settings = options || {};
      const rawValue = input.value.trim();

      clearFeedback();
      disableSubmit();

      if (tables.size === 0) {
        showError(messages.unavailable || 'Table ordering is currently unavailable.');
        return null;
      }

      if (!rawValue) {
        if (settings.showEmptyError) {
          showError(messages.empty || 'Enter your table number to continue.');
        }
        return null;
      }

      const tableNumber = parseTableNumber(rawValue);
      const table = tableNumber === null ? null : tables.get(tableNumber);

      if (!table) {
        showError(
          messageForTable(
            messages.invalid || 'We could not find table [table]. Please check the number and try again.',
            rawValue,
            ''
          )
        );
        return null;
      }

      enableSubmit(table.url);
      status.textContent = messageForTable(
        messages.available || '[table] · [area]',
        table.name || 'Table ' + tableNumber,
        table.area
      );
      status.hidden = !status.textContent;

      return table;
    }

    input.disabled = tables.size === 0;

    if (tables.size === 0) {
      validate();
    }

    input.addEventListener('input', function () {
      validate({ showEmptyError: false });
    });

    input.addEventListener('change', function () {
      validate({ showEmptyError: false });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const table = validate({ showEmptyError: true });
      if (table) window.location.assign(table.url);
    });

    const queryParameter = String(configuration.queryParameter || 'table_no').trim();
    const requestedTable = queryParameter
      ? parameters.get(queryParameter)
      : null;

    if (requestedTable !== null) {
      input.value = requestedTable;
      const table = validate({ showEmptyError: true });
      if (table) window.location.replace(table.url);
    }
  }

  function initializeAll(container) {
    const scope = container || document;

    if (scope.matches && scope.matches('[data-online-ordering]')) {
      initialize(scope);
    }

    scope.querySelectorAll('[data-online-ordering]').forEach(initialize);
  }

  if (window.FoodieOnlineOrdering) {
    window.FoodieOnlineOrdering.initializeAll(document);
    return;
  }

  window.FoodieOnlineOrdering = {
    initializeAll: initializeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
